var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.75C5 3.336 5.336 3 5.75 3H15.25C15.664 3 16 3.336 16 3.75V8H19.25C19.664 8 20 8.336 20 8.75V20H21C21.552 20 22 20.448 22 21C22 21.552 21.552 22 21 22H3C2.448 22 2 21.552 2 21C2 20.448 2.448 20 3 20H4V4.75C4 4.198 4.448 3.75 5 3.75ZM7 6H9V8H7V6ZM12 6H14V8H12V6ZM7 10H9V12H7V10ZM12 10H14V12H12V10ZM7 14H9V16H7V14ZM12 14H14V16H12V14ZM17 10H18.5V12H17V10ZM17 14H18.5V16H17V14ZM9 20H13V18H9V20Z",
    fill: "#241CCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.8f5e1377bd6f43d02e9610190014e66e.svg";
export { ForwardRef as ReactComponent };